import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Label, Icon, Message, Segment, Image, Popup } from 'semantic-ui-react';
import { LicenseListRow, Help } from 'components';

import * as common from 'libs/commonFunc';

import moment from 'moment';

import classNames from 'classnames/bind';
import styles from './LicenseList.css';
const cx = classNames.bind(styles);

class LicenseList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isAuth, licenseData, targetAllCount } = this.props;

    // 라이센스 총 개수
    let totalLicenseCount = 0;
    // 사용 가능한 기간 라이센스 총 수량
    let totalPeriodLicenseCnt = 0;
    // 사용 가능한 횟수 라이센스 총 수량
    let totalTimesLicenseCnt = 0;
    // 총 대상자와 라이센스 수량 비교
    let totalLicenseCnt = 0;
    // 사용중인 라이센스 타입 구분
    const licenseType = 0;
    const nowEpoch = common.nowEpoch();
    const licenseDataByNo = {};
    // 도메인별 라이센스 정보
    const domainData = {};
    const noLicenseData = null;
    // 발급된 라이센스 별 정보
    const existLicenseData = {
      // 횟수 라이센스
      times: {
        byNo: {},
        total: [],
        // 신청중
        notIssued: [],
        // 모든 횟수 사용
        expired: [],
        // 사용 가능
        using: []
      },
      // 기간 라이센스
      period: {
        byNo: {},
        total: [],
        // 신청중
        notIssued: [],
        // 만료
        expired: [],
        // 사용중
        using: [],
        // 정상이나 아직 사용기간이 안됨 (앞으로 사용할 라이센스)
        expected: []
      }
    };
    for (let i = 0, l = licenseData.length; i < l; i++) {
      const licenseInfo = licenseData[i];
      const {
        serviceNo,
        licenseNo,
        serviceName,
        startEpoch,
        endEpoch,
        licenseCount,
        licenseType,
        examUsedCount,
        examLimitCount,
        examLimitInfo,
        regEpoch,
        issueEpoch,
        targetCount,
        approve,
        status,
        licenseEnabled
      } = licenseInfo;

      // 라이센스 존재
      if (!!licenseNo) {
        licenseDataByNo[licenseNo] = licenseInfo;
        totalLicenseCount += 1;

        // 발급 받은 라이센스 (승인)
        if (!!issueEpoch) {
          // 횟수 라이센스
          if (licenseType === 4) {
            existLicenseData['times']['total'].push(licenseNo);
            // 만료
            if (examUsedCount === examLimitCount) {
              existLicenseData['times']['byNo'][licenseNo] = 3;
              existLicenseData['times']['expired'].push(licenseNo);

              // ----------- 관리자가 이미 사용한 횟수보다 수량 적게 변경했을때 리스트 뜨도록 처리 -----------
              //   // 사용중
              // } else if (examUsedCount < examLimitCount) {
            } else {
              existLicenseData['times']['byNo'][licenseNo] = 1;
              existLicenseData['times']['using'].push(licenseNo);

              if (totalTimesLicenseCnt < licenseCount) {
                totalTimesLicenseCnt = licenseCount;
              }
            }

            // ----------- 관리자가 이미 사용한 횟수보다 수량 적게 변경했을때 리스트 뜨도록 처리 -----------
            //   // 버그
            // } else {
            //   console.log('횟수 라이센스 버그');
            // }

            //기간 라이센스 (+ 영구 라이센스)
          } else if (licenseType === 1 || licenseType === 2) {
            existLicenseData['period']['total'].push(licenseNo);

            // 만료
            if (nowEpoch > endEpoch || status === 3) {
              existLicenseData['period']['byNo'][licenseNo] = 3;
              existLicenseData['period']['expired'].push(licenseNo);

              // 사용중 - 훈련 가능
            } else if (nowEpoch >= startEpoch && nowEpoch <= endEpoch) {
              existLicenseData['period']['byNo'][licenseNo] = 1;
              existLicenseData['period']['using'].push(licenseNo);
              totalPeriodLicenseCnt += licenseCount;

              // 사용 대기 - 정상이나 아직 사용기간이 안됨 (앞으로 사용할 라이센스)
            } else if (nowEpoch < startEpoch) {
              existLicenseData['period']['byNo'][licenseNo] = 2;
              existLicenseData['period']['expected'].push(licenseNo);
              totalPeriodLicenseCnt += licenseCount;
            } else {
              //
              console.log('기간 라이센스 버그');
            }
          } else {
            // 버그
            console.log('기간 라이센스 버그');
          }

          // 발급 안된 라이센스 (신청중)
        } else {
          // 횟수 라이센스
          if (licenseType === 4) {
            existLicenseData['times']['byNo'][licenseNo] = 0;
            existLicenseData['times']['total'].push(licenseNo);
            existLicenseData['times']['notIssued'].push(licenseNo);

            //기간 라이센스 (+ 영구 라이센스)
          } else if (licenseType === 1 || licenseType === 2) {
            existLicenseData['period']['byNo'][licenseNo] = 0;
            existLicenseData['period']['total'].push(licenseNo);
            existLicenseData['period']['notIssued'].push(licenseNo);
          }
        }
      }
    }

    // --------------------------------- rendering 시작 -------------------------------------
    const licenseSummaryDetail = [];
    const licenseSummaryData = {
      color: '',
      icon: '',
      text: '',
      sub: ''
    };

    // 기간 라이센스 정보 및 상태--------------------------------------------------------
    const periodStatusInfo = [];
    const periodNotIssuedCnt = existLicenseData['period']['notIssued'].length;
    const periodUsingCnt = existLicenseData['period']['using'].length;
    const periodExpiredCnt = existLicenseData['period']['expired'].length;
    const periodExpectedCnt = existLicenseData['period']['expected'].length;

    // 신청중
    if (periodNotIssuedCnt > 0) {
      existLicenseData['period']['notIssued'].map((licenseNo, index) => {
        periodStatusInfo.push(
          <div key={licenseNo} className={cx('license-status-item')}>
            <div className={cx('license-status-title', 'license-request')}>
              {index === 0 ? (
                <span>
                  <Image src="/img/setting/alert.png" />{' '}
                  {defineMessages(formatMessage({ id: 'LicenseList_1', defaultMessage: '신청중' }))}
                </span>
              ) : (
                ''
              )}
            </div>
            <div>
              <span className={cx('license-number')}>#{licenseNo} </span>
              <span className={cx('license-count')}>
                {licenseDataByNo[licenseNo].targetUsedCount} /{' '}
                {licenseDataByNo[licenseNo].licenseCount +
                  defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
              </span>
              <span className={cx('license-date')}>
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].startEpoch, 3)} ~{' '}
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].endEpoch, 3)}
              </span>
            </div>
          </div>
        );
      });
    }
    // 사용중
    if (periodUsingCnt > 0) {
      existLicenseData['period']['using'].map((licenseNo, index) => {
        periodStatusInfo.push(
          <div key={licenseNo} className={cx('license-status-item')}>
            <div className={cx('license-status-title', 'license-use')}>
              {index === 0 ? (
                <span>
                  <Image src="/img/setting/check.png" />{' '}
                  {defineMessages(formatMessage({ id: 'LicenseList_2', defaultMessage: '사용중' }))}
                </span>
              ) : (
                ''
              )}
            </div>
            <div>
              <span className={cx('license-number')}>#{licenseNo} </span>
              <span className={cx('license-count')}>
                {licenseDataByNo[licenseNo].targetUsedCount} /{' '}
                {licenseDataByNo[licenseNo].licenseCount +
                  defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
              </span>
              <span className={cx('license-date')}>
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].startEpoch, 3)} ~{' '}
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].endEpoch, 3)}
              </span>
            </div>
          </div>
        );
      });
    }
    // 만료
    if (periodExpiredCnt > 0) {
      existLicenseData['period']['expired'].map((licenseNo, index) => {
        periodStatusInfo.push(
          <div key={licenseNo} className={cx('license-status-item')}>
            <div className={cx('license-status-title', 'license-expired')}>
              {index === 0 ? (
                <span>
                  <Image src="/img/setting/forbidden.png" />{' '}
                  {defineMessages(formatMessage({ id: 'LicenseList_4', defaultMessage: '만료' }))}
                </span>
              ) : (
                ''
              )}
            </div>
            <div>
              <span className={cx('license-number')}>#{licenseNo} </span>
              <span className={cx('license-count')}>
                {licenseDataByNo[licenseNo].targetUsedCount} /{' '}
                {licenseDataByNo[licenseNo].licenseCount +
                  defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
              </span>
              <span className={cx('license-date')}>
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].startEpoch, 3)} ~{' '}
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].endEpoch, 3)}
              </span>
            </div>
          </div>
        );
      });
    }
    // 사용대기
    if (periodExpectedCnt > 0) {
      existLicenseData['period']['expected'].map((licenseNo, index) => {
        periodStatusInfo.push(
          <div key={licenseNo} className={cx('license-status-item')}>
            <div className={cx('license-status-title', 'license-ready')}>
              {index === 0 ? (
                <span>
                  <Image src="/img/setting/waiting.png" />{' '}
                  {defineMessages(formatMessage({ id: 'LicenseList_3', defaultMessage: '사용대기' }))}
                </span>
              ) : (
                ''
              )}
            </div>
            <div>
              <span className={cx('license-number')}>#{licenseNo} </span>
              <span className={cx('license-count')}>
                {licenseDataByNo[licenseNo].targetUsedCount} /{' '}
                {licenseDataByNo[licenseNo].licenseCount +
                  defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
              </span>
              <span className={cx('license-date')}>
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].startEpoch, 3)} ~{' '}
                {common.timeFormatFromUTCEpoch(licenseDataByNo[licenseNo].endEpoch, 3)}
              </span>
            </div>
          </div>
        );
      });
    }

    // 횟수 라이센스 정보 및 상태--------------------------------------------------------
    const timesStatusInfo = [];
    const timesNotIssuedCnt = existLicenseData['times']['notIssued'].length;
    const timesUsingCnt = existLicenseData['times']['using'].length;
    const timesExpiredCnt = existLicenseData['times']['expired'].length;
    // const timesExpectedCnt = existLicenseData['times']['expected'].length;

    // 신청중
    if (timesNotIssuedCnt > 0) {
      existLicenseData['times']['notIssued'].map((licenseNo, index) => {
        timesStatusInfo.push(
          <div key={licenseNo} className={cx('license-status-item')}>
            <div className={cx('license-status-title', 'license-request')}>
              {index === 0 ? (
                <span>
                  <Image src="/img/setting/alert.png" />{' '}
                  {defineMessages(formatMessage({ id: 'LicenseList_1', defaultMessage: '신청중' }))}
                </span>
              ) : (
                ''
              )}
            </div>
            <div>
              <span className={cx('license-number')}>#{licenseNo} </span>
              <span className={cx('license-count')}>
                {licenseDataByNo[licenseNo].licenseCount +
                  defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
              </span>
              <span className={cx('license-count', 'license-count-last')}>
                {licenseDataByNo[licenseNo].examUsedCount} / {licenseDataByNo[licenseNo].examLimitCount}
                {defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))}
              </span>
            </div>
          </div>
        );
      });
    }
    // 사용중
    if (timesUsingCnt > 0) {
      existLicenseData['times']['using'].map((licenseNo, index) => {
        timesStatusInfo.push(
          <div key={licenseNo} className={cx('license-status-item')}>
            <div className={cx('license-status-title', 'license-use')}>
              {index === 0 ? (
                <span>
                  <Image src="/img/setting/check.png" />{' '}
                  {defineMessages(formatMessage({ id: 'LicenseList_2', defaultMessage: '사용중' }))}
                </span>
              ) : (
                ''
              )}
            </div>
            <div>
              <span className={cx('license-number')}>#{licenseNo} </span>
              <span className={cx('license-count')}>
                {licenseDataByNo[licenseNo].licenseCount +
                  defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
              </span>
              <span className={cx('license-count', 'license-count-last')}>
                {licenseDataByNo[licenseNo].examUsedCount} / {licenseDataByNo[licenseNo].examLimitCount}
                {defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))}
              </span>
            </div>
          </div>
        );
      });
    }
    // 만료
    if (timesExpiredCnt > 0) {
      existLicenseData['times']['expired'].map((licenseNo, index) => {
        timesStatusInfo.push(
          <div key={licenseNo} className={cx('license-status-item')}>
            <div className={cx('license-status-title', 'license-expired')}>
              {index === 0 ? (
                <span>
                  <Image src="/img/setting/forbidden.png" />{' '}
                  {defineMessages(formatMessage({ id: 'LicenseList_4', defaultMessage: '만료' }))}
                </span>
              ) : (
                ''
              )}
            </div>
            <div>
              <span className={cx('license-number')}>#{licenseNo} </span>
              <span className={cx('license-count')}>
                {licenseDataByNo[licenseNo].licenseCount +
                  defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
              </span>
              <span className={cx('license-count', 'license-count-last')}>
                {licenseDataByNo[licenseNo].examUsedCount} /{' '}
                {licenseDataByNo[licenseNo].examLimitCount +
                  defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))}
              </span>
            </div>
          </div>
        );
      });
    }

    licenseSummaryDetail.push(
      <div key={existLicenseData['period']['byNo']}>
        {/* 기간 */}
        {existLicenseData['period']['total'] &&
          existLicenseData['period']['total'].length > 0 && (
            <div className={cx('target-domain-list')}>
              <Label basic className={cx('target-domain')} size="large">
                {defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }))}
                <Label.Detail>
                  {'( ' +
                    existLicenseData['period']['total'].length +
                    ' ' +
                    defineMessages(formatMessage({ id: 'AdminLicenseList_26', defaultMessage: '개' })) +
                    ' )'}
                </Label.Detail>
              </Label>
              <Label
                className={cx('target-domain-license')}
                basic
                color={licenseSummaryData.color === 'red' ? licenseSummaryData.color : null}
                size="large">
                <div className={cx('license-state')}>
                  <div>{periodStatusInfo}</div>
                  <div>{/* {licenseSummaryData.text}
                    {licenseSummaryData.sub} */}</div>
                </div>
              </Label>
            </div>
          )}
        {/* 횟수 */}
        {existLicenseData['times']['total'] &&
          existLicenseData['times']['total'].length > 0 && (
            <div className={cx('target-domain-list')}>
              <Label basic className={cx('target-domain')} size="large">
                {defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))}
                <Label.Detail>
                  {'( ' +
                    existLicenseData['times']['total'].length +
                    ' ' +
                    defineMessages(formatMessage({ id: 'AdminLicenseList_26', defaultMessage: '개' })) +
                    ' )'}
                </Label.Detail>
              </Label>
              <Label
                className={cx('target-domain-license')}
                basic
                color={licenseSummaryData.color === 'red' ? licenseSummaryData.color : null}
                size="large">
                <div className={cx('license-state')}>
                  <div>
                    {timesStatusInfo}
                    {/* {licenseSummaryData.text}
                    {licenseSummaryData.sub} */}
                  </div>
                </div>
              </Label>
            </div>
          )}
      </div>
    );

    // 라이센스 타이틀 정보
    let licenseSummaryInfo = {
      icon: 'info',
      header: '',
      sub: ''
    };

    // 총 대상자와 총 라이센스 수량을 비교
    // 기간 & 횟수 모두 존재
    if (existLicenseData['period']['total'].length > 0 && existLicenseData['times']['total'].length > 0) {
      // 기간의 사용 가능한 라이센스의 총 수량이 총 대상자 수를 만족
      if (totalPeriodLicenseCnt >= targetAllCount) {
        totalLicenseCnt = totalPeriodLicenseCnt;
        // 기간이 만족하지 못했을 경우 횟수
      } else {
        totalLicenseCnt = totalTimesLicenseCnt;
      }
      // 기간만 존재
    } else if (existLicenseData['period']['total'].length > 0) {
      totalLicenseCnt = totalPeriodLicenseCnt;
      // 횟수만 존재
    } else {
      totalLicenseCnt = totalTimesLicenseCnt;
    }

    if (targetAllCount <= 0) {
      // 대상자를 등록하세요
      licenseSummaryInfo = {
        icon: <Image src="/img/setting/license-register.png" />,
        header: defineMessages(formatMessage({ id: 'LicenseList_12', defaultMessage: '먼저 훈련 대상을 등록하세요.' })),
        color: 'error',
        sub: defineMessages(
          formatMessage({
            id: 'LicenseList_13',
            defaultMessage: '훈련 대상자가 없습니다. 먼저 훈련 대상자를 등록하세요.'
          })
        )
      };
    } else if (targetAllCount < 6) {
      // 라이센스 불필요. 대상자가 5명 이하의 경우 라이센스가 필요 하지 않습니다
      licenseSummaryInfo = {
        color: 'success',
        icon: <Image src="/img/setting/license-check.png" />,
        header: defineMessages(formatMessage({ id: 'LicenseList_10', defaultMessage: '라이센스 불필요' })),
        sub: defineMessages(
          formatMessage({
            id: 'LicenseList_18',
            defaultMessage: '대상자가 5명 이하의 경우 라이센스가 필요 하지 않습니다.'
          })
        )
      };
    } else if (totalLicenseCount <= 0) {
      // 라이센스 발급 필요
      licenseSummaryInfo = {
        color: 'error',
        icon: <Image src="/img/setting/license-warning.png" />,
        header: defineMessages(formatMessage({ id: 'LicenseList_14', defaultMessage: '라이센스 발급이 필요합니다.' })),
        sub: defineMessages(
          formatMessage({
            id: 'LicenseList_22',
            defaultMessage: "훈련 진행을 위한 '라이센스'를 구매하세요."
          })
        )
      };
    } else if (totalLicenseCnt < targetAllCount) {
      // 발급 라이센스가 등록 대상자보다 적습니다
      licenseSummaryInfo = {
        color: 'error',
        icon: <Image src="/img/setting/license-check.png" />,
        header: defineMessages(
          formatMessage({ id: 'LicenseList_23', defaultMessage: '발급 라이센스가 등록 된 대상자보다 적습니다.' })
        ),
        sub: defineMessages(
          formatMessage({
            id: 'LicenseList_24',
            defaultMessage: '원활한 훈련 진행을 위해서는 라이센스 추가 발급이 필요합니다.'
          })
        )
      };
    } else if (targetAllCount <= totalLicenseCnt) {
      // 적합한 라이센스
      licenseSummaryInfo = {
        color: 'success',
        icon: <Image src="/img/setting/license-check.png" />,
        header: defineMessages(
          formatMessage({ id: 'LicenseList_25', defaultMessage: '훈련에 적합한 라이센스가 발급되어 있습니다.' })
        ),
        sub: defineMessages(
          formatMessage({
            id: 'LicenseList_30',
            defaultMessage: '모든 훈련 대상자에 해당하는 라이센스가 발급되었습니다.'
          })
        )
      };
    }

    const licenseSummary = (
      <Segment.Group raised className={cx('license-user-summary-box')}>
        <Message
          attached
          icon
          // success={licenseSummaryInfo.color === 'success'}
          // error={licenseSummaryInfo.color === 'error'}
          className={cx('license-user-result')}>
          {licenseSummaryInfo.icon}
          <Message.Content>
            <Message.Header>{licenseSummaryInfo.header}</Message.Header>
            {licenseSummaryInfo.sub}
          </Message.Content>
        </Message>
        {targetAllCount > 0 &&
          totalLicenseCount > 0 && (
            <Segment attached="bottom" className={cx('license-user-detail')}>
              {licenseSummaryDetail.length > 0
                ? licenseSummaryDetail
                : defineMessages(
                    formatMessage({ id: 'StartExamWizardContent_64', defaultMessage: '훈련 대상자 없음' })
                  )}
            </Segment>
          )}
      </Segment.Group>
    );

    // ----------------- 라이센스별 정보 -----------------
    // 횟수 라이센스
    const timesLicenseGrid = [];
    existLicenseData['times']['total'].map(licenseNo => {
      timesLicenseGrid.push(
        <LicenseListRow
          key={licenseNo}
          licenseInfo={licenseDataByNo[licenseNo]}
          existLicenseType="times"
          existLicenseData={existLicenseData}
        />
      );
    });
    // 기간 라이센스
    const periodLicenseGrid = [];
    existLicenseData['period']['total'].map(licenseNo => {
      periodLicenseGrid.push(
        <LicenseListRow
          key={licenseNo}
          licenseInfo={licenseDataByNo[licenseNo]}
          existLicenseType="period"
          existLicenseData={existLicenseData}
        />
      );
    });

    const licenseGrid = (
      <div>
        {!!periodLicenseGrid &&
          periodLicenseGrid.length > 0 && (
            <div className={cx('mt-30')}>
              <div className={cx('bold font-size-20 mb-10')}>
                {defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }))}
              </div>
              <div>{periodLicenseGrid}</div>
            </div>
          )}
        {!!timesLicenseGrid &&
          timesLicenseGrid.length > 0 && (
            <div className={cx('mt-30')}>
              <div className={cx('bold font-size-20 mb-10')}>
                {defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))}
              </div>
              <div>{timesLicenseGrid}</div>
            </div>
          )}
      </div>
    );

    return (
      <div className={cx('license-grid-box')}>
        {licenseSummary}
        {licenseGrid}
      </div>
    );
  }
}

export default injectIntl(LicenseList);



// WEBPACK FOOTER //
// ./src/script/components/license/LicenseList.js